import { CircleNotch } from '@phosphor-icons/react';

// Full-screen boot splash shared across every pre-render gate (feature flags,
// router hydrate, ProtectedRoutes session resolution) so the entire cold load
// shows one consistent screen instead of flashing between different loaders.
const BootSplash = () => (
	<div className='flex h-dvh items-center justify-center bg-h-bg-app'>
		<CircleNotch
			className='animate-spin text-h-primary-50'
			size={32}
			weight='bold'
		/>
	</div>
);

export default BootSplash;
